import { createContext } from "react";

export const LoansContext = createContext(null);